var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.982 7.375c-.014-.16-.372-.468-.523-.523a.416.416 0 0 0-.436.096l-2.29 2.29-2.974-2.974 2.336-2.327a.412.412 0 0 0 .096-.434c-.055-.15-.422-.471-.583-.485a4.808 4.808 0 0 0-3.813 1.384 4.78 4.78 0 0 0-1.095 5.08c-.07.059-.14.121-.209.189l-7.795 7.328-.009.009a2.34 2.34 0 0 0 0 3.313 2.347 2.347 0 0 0 3.326-.023l7.292-7.827c.066-.066.128-.136.186-.207a4.826 4.826 0 0 0 5.102-1.09 4.77 4.77 0 0 0 1.389-3.799z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.ddad1d86020dfb206ca59981061379ba.svg";
export { ForwardRef as ReactComponent };